<template>
    <div class="page-wrapper">
        <Header/>
        <div class="wrapper">
            <div class="page">
                <div class="container">
                    <div class="page-title">Тарифы</div>
                    <div class="tariff-msg">
                        <template v-if="!userLoggedIn">
                            <router-link :to="{name: 'Registration'}"
                                         @click.native="saveRedirect">Зарегистрируйтесь
                            </router-link>
                            , чтобы получить функционал &laquo;Базового&raquo; тарифа бесплатно
                        </template>
                        <template v-else-if="!proTariffActive">
                            Подключите тариф PRO для получения доступа ко всему функционалу
                        </template>
                        <template v-else-if="['ROLE_ADMIN', 'ROLE_SUPER'].includes(currentUserRole)">
                            Вы - администратор, и Вам всегда будут доступны возможности PRO-тарифа.
                        </template>
                        <template v-else-if="!!currentSubscription.trial">
                            Пробный период закончится <span v-html="trialFormattedDaysLeft"/>
                        </template>
                        <template v-else-if="proTariffActive">
                            До завершения периода действия тарифа PRO &nbsp;<span
                                v-html="paidformattedDaysLeft"/>
                        </template>
                    </div>
                    <div class="tariff-list visibility">

                        <div class="tariff-item tariff-free">
                            <div class="title">Базовый</div>
                            <div class="price"><span>0</span></div>
                            <div class="time">в&nbsp;месяц</div>
                            <div class="advantages">
                                <ul>
                                    <li>Натальная карта + Таблица аспектов</li>
                                    <li>Бодиграф + Таблицы «Личность» и «Дизайн»</li>
                                    <li>Транзит + Таблица аспектов</li>
                                    <li>Отображение информации о типе и профиле</li>
                                    <li>Расчет транзита, натальной карты и бодиграфа на одной астродизайн карте</li>
                                    <li>Расчет Дирекций и Прогрессий</li>
                                    <li>Таблица Фирдаров</li>
                                    <li>Сохранение карт</li>
                                </ul>
                            </div>
                            <div class="buttons">
                                <template v-if="!!userLoggedIn && !standardTariffActive && !proTariffActive">
                                  <a href="registration.htm" class="button blue-button">Зарегистрироваться</a>
                                </template>
                                <template v-else-if="proTariffActive">
                                  <div class="tariff-info">После завершения тарифа PRO, подключится автоматически</div>
                                </template>
                                <template v-else-if="standardTariffActive">
                                    <div class="tariff-active"><i class="fa fa-check" aria-hidden="true"></i> <span>Тариф подключен</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <button type="submit" class="button blue-button"
                                            :disabled="!!queryIsPerforming"
                                            @click.stop.prevent="activateStandardTariff">
                                      Зарегистрироваться
                                    </button>
                                </template>
                            </div>
                        </div>

                        <div class="tariff-item tariff-pro">
                            <div class="title">PRO</div>
                            <div class="price"><span>{{ formattedPrice.pro }}</span></div>
                            <div class="time">в&nbsp;месяц</div>
                            <div class="advantages">
                                <ul>
                                    <li><strong>Режим мультикарты для определения точного времени рождения</strong></li>
                                    <li>Натальная карта + Таблица аспектов</li>
                                    <li>Бодиграф + Таблицы «Личность» и «Дизайн»</li>
                                    <li>Транзит + Таблица аспектов</li>
                                    <li>Отображение информации о типе и профиле</li>
                                    <li>Расчет транзита, натальной карты и бодиграфа на одной астродизайн карте</li>
                                    <li>Расчет Дирекций и Прогрессий</li>
                                    <li>Таблица Фирдаров</li>
                                    <li>Сохранение карт</li>
                                </ul>
                            </div>
                            <div class="promocode" v-if="!!userLoggedIn && !proTariffActive">
                                <div class="promocode-toggler">
                                    <span @click="promocodeShown = !promocodeShown">У меня есть промокод</span>
                                </div>
                                <div class="promocode-form" :class="{'block-hidden': !promocodeShown}">
                                    <form action="">
                                        <input type="text" class="promocode-form-field" placeholder="Введите код"
                                               v-model="promocode">
                                        <button class="button trans-button promocode-form-btn"
                                                @click.prevent="applyPromocode">Применить
                                        </button>
                                    </form>
                                </div>
                            </div>
                            <div class="buttons">
                                <template v-if="proTariffActive">
                                    <div class="tariff-active"><i class="fa fa-check" aria-hidden="true"></i> <span>Тариф подключен</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <select-payment-mode v-if="!!userLoggedIn"
                                                         v-model="yandexPaymentData.paymentType"/>
                                    <button type="submit" class="button blue-button"
                                            :disabled="!!queryIsPerforming"
                                            @click.stop.prevent="activateProTariff">
                                        Подключить
                                    </button>
                                </template>
                            </div>
                        </div>

                        <template v-if="!!userLoggedIn && !proTariffActive">
                            <form ref="yandexPaymentForm" action="https://yoomoney.ru/quickpay/confirm.xml">
                                <input type="hidden" name="receiver" :value="yandexPaymentData.receiver"/>
                                <input type="hidden" name="quickpay-form" value="shop"/>
                                <input type="hidden" name="targets"
                                       value="Подключение платного тарифа Astroprocessor"/>
                                <input type="hidden" name="paymentType" :value="yandexPaymentData.paymentType"/>
                                <input type="hidden" name="sum" data-type="number" :value="yandexForm.sum"/>
                                <input type="hidden" name="label" :value="yandexPaymentData.label"/>
                                <input type="hidden" name="formcomment" :value="yandexForm.comment"/>
                                <input type="hidden" name="short-dest" :value="yandexForm.comment"/>
                                <input type="hidden" name="successURL" :value="yandexForm.redirectUrl"/>
                            </form>
                        </template>
                    </div>
                </div>
            </div>
            <div class="page-buffer"></div>
        </div>
        <Footer/>
    </div>
</template>

<script>
    import constants from '@/constants';
    import utils from '@/utils';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import SelectPaymentMode from '@/components/SelectPaymentMode';

    export default {
        name: "Tariff",

        components: {
            Header, Footer, SelectPaymentMode
        },

        data() {
            return {
                trialDays: null,
                price: {
                    pro: constants.price.PRO / 100
                },

                promocode: null,
                promocodeShown: false,

                yandexPaymentData: {
                    receiver: null,
                    tariff: constants.tariff.STANDARD,
                    paymentType: constants.yandexMoney.paymentTypes.wallet,
                    // Требуется для определения, по какой оплате пришёл колбэк
                    label: null
                }
            }
        },

        watch: {
            userLoggedIn(val) {
                if (!!val) {
                    this.$store.dispatch('getCurrentSubscription');
                }
            }
        },

        computed: {
            queryIsPerforming() {
                return this.$store.getters.restQueryIsPerforming;
            },

            userLoggedIn() {
                let token = this.$store.getters.token;
                return !!token && token.length > 0;
            },

            currentUserRole() {
                return this.$store.getters.currentUser.role;
            },

            currentSubscription() {
                return this.$store.getters.currentSubscription;
            },

            formattedPrice() {
                let a = (!!this.price.pro) ? {
                    pro: this.formatPrice(this.price.pro)
                } : {
                    pro: ''
                };
                return a;
            },

            trialFormattedDaysLeft() {
                if (!this.userLoggedIn || !this.currentSubscription)
                    return '';

                let daysLeft = this.currentSubscription.daysLeft;
                if (daysLeft == 0 || daysLeft == 1) {
                    return 'сегодня, подключите один из платных тарифов, чтобы продолжить пользоваться расширенным функционалом';
                } else {
                    let daysInclined = utils.inclineNumeral(daysLeft, ['день', 'дня', 'дней']);
                    return `через ${daysLeft}&nbsp;${daysInclined}`;
                }
            },

            paidformattedDaysLeft() {
                if (!this.userLoggedIn || !this.currentSubscription)
                    return '';

                let daysLeft = this.currentSubscription.daysLeft;
                if (daysLeft == 0 || daysLeft == 1) {
                    return 'остались считанные часы';
                } else {
                    let daysInclined = utils.inclineNumeral(daysLeft, ['день', 'дня', 'дней']);
                    let leftInclined = utils.inclineNumeral(daysLeft, ['остался', 'осталось', 'осталось']);

                    return `${leftInclined} ${daysLeft}&nbsp;${daysInclined}`;
                }
            },

            hasSubscription() {
                return !!this.userLoggedIn
                    && this.currentSubscription
                    && !this.currentSubscription.trial;
            },

            standardTariffActive() {
                return this.userLoggedIn;
            },

            proTariffActive() {
                return this.hasSubscription
                    && this.currentSubscription.tariff === constants.tariff.PRO;
            },

            yandexForm() {
                return {
                    sum: this.price.pro,
                    comment: 'Astroprocessor: подключение PRO-тарифа',
                    redirectUrl: process.env.VUE_APP_FRONT_GLOBAL_URL + '/tariff?paymentAccepted=true&tariffType=' + this.yandexPaymentData.tariff
                }
            }
        },

        async created() {
            if (!!this.userLoggedIn) {
              await this.$store.dispatch('getCurrentSubscription');
            }
            let paymentAccepted = this.$route.query.paymentAccepted;
            if (!!paymentAccepted) {
                alert(`Оплата прошла успешно. PRO-тариф скоро будет вам подключён!`);
                let query = Object.assign({}, this.$route.query);
                delete query.paymentAccepted;
                this.$router.replace({query});
            }

            this.trialDays = await this.$store.dispatch('getTrialDays');
            this.price = await this.getPrice();

            this.yandexPaymentData.receiver = await this.$store.dispatch('getWallet');
        },

        methods: {
            saveRedirect() {
                sessionStorage.setItem(constants.SESSION_STORAGE_REDIRECT, '/tariff');
            },

            async getPrice(promocode) {
                return await this.$store.dispatch('getPrice', promocode);
            },

            formatPrice(price) {
                return parseFloat(price.toString()).toFixed(0);
            },

            async applyPromocode() {
                if (!this.promocode || !!this.queryIsPerforming)
                    return;

                let price = await this.getPrice(this.promocode);
                if (!!price)
                    this.price = price;
            },

            activateFreeTariff() {
                this.saveRedirect();
                this.$router.push({name: 'Login'});
            },

            activateStandardTariff() {
              this.saveRedirect();
              this.$router.push({name: 'Registration'});
            },

            activateProTariff() {
                this.activateTariff(constants.tariff.PRO);
            },

            async activateTariff(tariff) {
                if (!tariff)
                    return;

                this.yandexPaymentData.tariff = tariff;

                if (!this.userLoggedIn) {
                    this.saveRedirect();
                    this.$router.push({name: 'Login'});
                } else if (!this.currentSubscription
                    || !!this.currentSubscription.trial
                    // PRO-тариф можно подключить поверх активного базового тарифа
                    || (tariff === constants.tariff.PRO && this.currentSubscription.tariff !== constants.tariff.PRO)) {
                    let payload = {
                        tariff: tariff,
                        promocode: this.promocode
                    };
                    let paymentEntry = await this.$store.dispatch('createPaymentRequest', payload);
                    if (!!paymentEntry) {
                        this.yandexPaymentData.label = paymentEntry.code;
                        this.$nextTick(() => this.$refs.yandexPaymentForm.submit());
                    }
                }
            }
        }
    }
</script>
